const KOFI_REGEX = /^(http|https):\/\/(www\.)?ko-fi.com\/+([a-zA-Z0-9][\w]{2,30})/i;
const CALENDLY_REGEX = /^(https?:\/\/calendly.com\/([\w]+)\/?(\/[\w-]+)?\/?)/i;

// https://gist.github.com/fantattitude/3627354
const SPOTIFY_TRACK_REGEX = /^(https?:\/\/open.spotify.com\/track\/([a-zA-Z0-9]+))/i;
const SPOTIFY_PLAYLIST_REGEX = /^(https?:\/\/open.spotify.com\/playlist\/([a-zA-Z0-9]+))/i;
const SPOTIFY_ARTIST_REGEX = /^(https?:\/\/open.spotify.com\/artist\/([a-zA-Z0-9]+))/i;
const SPOTIFY_ALBUM_REGEX = /^(https?:\/\/open.spotify.com\/album\/([a-zA-Z0-9]+))/i;
const SPOTIFY_SHOW_REGEX = /^(https?:\/\/open.spotify.com\/show\/([a-zA-Z0-9]+))/i;
const SPOTIFY_EPISODE_REGEX = /^(https?:\/\/open.spotify.com\/episode\/([a-zA-Z0-9]+))/i;

// https://soundcloud.com/tomsize/twenty-one-pilots-stressed-out-tomsize-remix?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing
const SOUNDCLOUD_TRACK_REGEX = /^(https:\/\/soundcloud.com\/[a-zA-Z0-9-]+\/([a-zA-Z0-9-]+))/i;
// https://soundcloud.com/twentyonepilots/sets/scaled-and-icy-livestream
const SOUNDCLOUD_SETS_REGEX = /^(https:\/\/soundcloud.com\/[a-zA-Z0-9-]+\/sets\/([a-zA-Z0-9-]+))/i;

// https://music.apple.com/us/playlist/todays-hits/pl.f4d106fed2bd41149aaacabb233eb5eb
const APPLE_PLAYLIST_REGEX = /^(https:\/\/music.apple.com\/[a-z]+\/playlist\/[a-zA-Z0-9-]+\/pl.[a-zA-Z0-9-]+)/i;
// https://music.apple.com/us/album/what-it-means-to-be-king/1611984334
const APPLE_ALBUM_REGEX = /^(https:\/\/music.apple.com\/[a-z]+\/album\/[a-zA-Z0-9-]+\/[0-9]+)/i;
// https://music.apple.com/us/album/get-into-it-yuh/1571168930?i=1571169191
const APPLE_TRACK_REGEX = /^(https:\/\/music.apple.com\/[a-z]+\/album\/[a-zA-Z0-9-]+\/[0-9]+\?i=[0-9]+)/i;

// https://podcasts.apple.com/us/podcast/the-holderness-family-podcast/id1378725018
const APPLE_PODCAST_REGEX = /^(https:\/\/podcasts.apple.com\/[a-z]+\/podcast\/[a-zA-Z0-9-]+\/id[0-9]+)/i;

// export const COINBASE_COMMERCE_REGEX = /^(http|https):\/\/commerce.coinbase.com\/checkout\/+([a-zA-Z0-9][\w]{10,20})$/i;

function getKofiUsername(url) {
  const match = url.match(KOFI_REGEX);
  return match ? match[3] : false;
}
function getSpotifyId(url, embedOptions) {
  const match = url.match(embedOptions.urlPatterns[0]);
  return match ? match[2] : false;
}
function getPlatformUrl(url, embedOptions) {
  const match = url.match(embedOptions.urlPatterns[0]);
  return match ? match[1] : false;
}
function getCalendlyUrl(url, embedOptions) {
  const match = url.match(embedOptions.urlPatterns[0]);
  return match ? url : false;
}
const KOFI_PLATFORM_OPTIONS = {
  id: 'kofi',
  name: 'Ko-fi',
  urlPatterns: [KOFI_REGEX],
  getId: getKofiUsername,
  embedTypes: [{
    name: 'Embed my Ko-fi donation panel',
    value: 'embed',
    height: '712px'
  }],
  icon: 'KoFiIcon',
  iconColor: '#FF5E5B',
  type: 'platform'
};
const CALENDLY_PLATFORM_OPTIONS = {
  id: 'calendly',
  name: 'Calendly',
  urlPatterns: [CALENDLY_REGEX],
  getId: getCalendlyUrl,
  embedTypes: [{
    name: 'Embed my Calendly calendar',
    value: 'embed',
    height: '646px'
  }],
  icon: 'CalendlyIcon',
  type: 'platform',
  showOpenButton: true
};
const SHARED_SPOTIFY_OPTIONS = {
  name: 'Spotify',
  icon: 'SpotifyIcon',
  iconColor: '#1DB954',
  type: 'platform',
  getId: getSpotifyId,
  showOpenButton: true
};
const SHARED_SOUNDCLOUD_OPTIONS = {
  name: 'SoundCloud',
  icon: 'SoundcloudIcon',
  iconColor: '#ff5500',
  type: 'platform',
  getId: getPlatformUrl,
  showOpenButton: true
};
const SHARED_APPLE_OPTIONS = {
  name: 'Apple Music',
  icon: 'AppleIcon',
  iconColor: '#ff453a',
  type: 'platform',
  getId: getPlatformUrl,
  showOpenButton: true
};
const SPOTIFY_TRACK_PLATFORM_OPTIONS = {
  ...SHARED_SPOTIFY_OPTIONS,
  urlPatterns: [SPOTIFY_TRACK_REGEX],
  id: 'spotify_track',
  embedTypes: [{
    name: 'Embed the Spotify track on my profile',
    value: 'embed',
    height: '80px'
  }]
};
const SPOTIFY_PLAYLIST_PLATFORM_OPTIONS = {
  ...SHARED_SPOTIFY_OPTIONS,
  urlPatterns: [SPOTIFY_PLAYLIST_REGEX],
  id: 'spotify_playlist',
  embedTypes: [{
    name: 'Embed the Spotify playlist on my profile',
    value: 'embed',
    height: '380px'
  }]
};
const SPOTIFY_ARTIST_PLATFORM_OPTIONS = {
  ...SHARED_SPOTIFY_OPTIONS,
  urlPatterns: [SPOTIFY_ARTIST_REGEX],
  id: 'spotify_artist',
  embedTypes: [{
    name: 'Embed the Spotify artist on my profile',
    value: 'embed',
    height: '390px'
  }]
};
const SPOTIFY_ALBUM_PLATFORM_OPTIONS = {
  ...SHARED_SPOTIFY_OPTIONS,
  urlPatterns: [SPOTIFY_ALBUM_REGEX],
  id: 'spotify_album',
  embedTypes: [{
    name: 'Embed the Spotify album on my profile',
    value: 'embed',
    height: '380px'
  }]
};
const SPOTIFY_SHOW_PLATFORM_OPTIONS = {
  ...SHARED_SPOTIFY_OPTIONS,
  urlPatterns: [SPOTIFY_SHOW_REGEX],
  id: 'spotify_show',
  embedTypes: [{
    name: 'Embed the Spotify show on my profile',
    value: 'embed',
    height: '232px'
  }]
};
const SPOTIFY_EPISODE_PLATFORM_OPTIONS = {
  ...SHARED_SPOTIFY_OPTIONS,
  urlPatterns: [SPOTIFY_EPISODE_REGEX],
  id: 'spotify_episode',
  embedTypes: [{
    name: 'Embed the Spotify episode on my profile',
    value: 'embed',
    height: '232px'
  }]
};
const SOUNDCLOUD_TRACK_PLATFORM_OPTIONS = {
  ...SHARED_SOUNDCLOUD_OPTIONS,
  urlPatterns: [SOUNDCLOUD_TRACK_REGEX],
  id: 'soundcloud_track',
  embedTypes: [{
    name: 'Embed the Soundcloud track on my profile',
    value: 'embed',
    height: '166px'
  }]
};
const SOUNDCLOUD_SETS_PLATFORM_OPTIONS = {
  ...SHARED_SOUNDCLOUD_OPTIONS,
  urlPatterns: [SOUNDCLOUD_SETS_REGEX],
  id: 'soundcloud_sets',
  embedTypes: [{
    name: 'Embed the Soundcloud playlist on my profile',
    value: 'embed',
    height: '450px'
  }]
};
const APPLE_PLAYLIST_PLATFORM_OPTIONS = {
  ...SHARED_APPLE_OPTIONS,
  urlPatterns: [APPLE_PLAYLIST_REGEX],
  id: 'apple_playlist',
  embedTypes: [{
    name: 'Embed the Apple playlist on my profile',
    value: 'embed',
    height: '450px'
  }]
};
const APPLE_ALBUM_PLATFORM_OPTIONS = {
  ...SHARED_APPLE_OPTIONS,
  urlPatterns: [APPLE_ALBUM_REGEX],
  id: 'apple_album',
  embedTypes: [{
    name: 'Embed the Apple album on my profile',
    value: 'embed',
    height: '450px'
  }]
};
const APPLE_TRACK_PLATFORM_OPTIONS = {
  ...SHARED_APPLE_OPTIONS,
  urlPatterns: [APPLE_TRACK_REGEX],
  id: 'apple_track',
  embedTypes: [{
    name: 'Embed the Apple track on my profile',
    value: 'embed',
    height: '150px'
  }]
};
const APPLE_PODCAST_PLATFORM_OPTIONS = {
  id: 'apple_podcast',
  name: 'Apple Podcast',
  urlPatterns: [APPLE_PODCAST_REGEX],
  getId: getPlatformUrl,
  iconColor: '#B150E2',
  embedTypes: [{
    name: 'Embed the Apple podcast on my profile',
    value: 'embed',
    height: '450px'
  }],
  icon: 'ApplePodcastIcon',
  type: 'platform'
};
const PLATFORM_OPTIONS = [KOFI_PLATFORM_OPTIONS, CALENDLY_PLATFORM_OPTIONS, SPOTIFY_TRACK_PLATFORM_OPTIONS, SPOTIFY_PLAYLIST_PLATFORM_OPTIONS, SPOTIFY_ARTIST_PLATFORM_OPTIONS, SPOTIFY_ALBUM_PLATFORM_OPTIONS, SPOTIFY_SHOW_PLATFORM_OPTIONS, SPOTIFY_EPISODE_PLATFORM_OPTIONS, SOUNDCLOUD_SETS_PLATFORM_OPTIONS, SOUNDCLOUD_TRACK_PLATFORM_OPTIONS, APPLE_PLAYLIST_PLATFORM_OPTIONS, APPLE_TRACK_PLATFORM_OPTIONS, APPLE_ALBUM_PLATFORM_OPTIONS, APPLE_PODCAST_PLATFORM_OPTIONS];
export { APPLE_ALBUM_PLATFORM_OPTIONS, APPLE_ALBUM_REGEX, APPLE_PLAYLIST_PLATFORM_OPTIONS, APPLE_PLAYLIST_REGEX, APPLE_PODCAST_PLATFORM_OPTIONS, APPLE_PODCAST_REGEX, APPLE_TRACK_PLATFORM_OPTIONS, APPLE_TRACK_REGEX, CALENDLY_PLATFORM_OPTIONS, CALENDLY_REGEX, KOFI_PLATFORM_OPTIONS, KOFI_REGEX, PLATFORM_OPTIONS, SOUNDCLOUD_SETS_PLATFORM_OPTIONS, SOUNDCLOUD_SETS_REGEX, SOUNDCLOUD_TRACK_PLATFORM_OPTIONS, SOUNDCLOUD_TRACK_REGEX, SPOTIFY_ALBUM_PLATFORM_OPTIONS, SPOTIFY_ALBUM_REGEX, SPOTIFY_ARTIST_PLATFORM_OPTIONS, SPOTIFY_ARTIST_REGEX, SPOTIFY_EPISODE_PLATFORM_OPTIONS, SPOTIFY_EPISODE_REGEX, SPOTIFY_PLAYLIST_PLATFORM_OPTIONS, SPOTIFY_PLAYLIST_REGEX, SPOTIFY_SHOW_PLATFORM_OPTIONS, SPOTIFY_SHOW_REGEX, SPOTIFY_TRACK_PLATFORM_OPTIONS, SPOTIFY_TRACK_REGEX, getCalendlyUrl, getKofiUsername, getPlatformUrl, getSpotifyId };